export default __webpack_public_path__ + "static/media/back.199cfa70.svg";